module.exports = __WEBPACK_EXTERNAL_MODULE_4__;


//////////////////
// WEBPACK FOOTER
// external "@microsoft/sp-webpart-base"
// module id = 4
// module chunks = 0